var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "8.1 7.83 49.57 49.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-29.8%",
    y: "-29.6%",
    width: "159.7%",
    height: "159.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Earn-Interest-Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cosmos---Pending-Unstake",
    transform: "translate(-69.000000, -628.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(67.441895, 625.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(8.000000, 9.210449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.648620, 0.900605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.329894, 0.332176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glow",
    opacity: 0.34265718,
    transform: "translate(5.034906, 4.592661)",
    fill: "#F8E71C",
    fillOpacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape",
    opacity: 0.400000006,
    filter: "url(#filter-1)",
    cx: 20.2821251,
    cy: 20.4622429,
    rx: 20.1103586,
    ry: 20.2494542
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(0.561665, 0.261395)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Opacity",
    opacity: 0.0390532024,
    fill: "#F8E71C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9075,49.6773895 C11.2274678,49.6773895 0.137610497,38.5875322 0.137610497,24.9075 C0.137610497,11.2274678 11.2274678,0.137610497 24.9075,0.137610497 C38.5875322,0.137610497 49.6773895,11.2274678 49.6773895,24.9075 C49.6773895,38.5875322 38.5875322,49.6773895 24.9075,49.6773895 Z M24.9075,49.4021685 C38.4355319,49.4021685 49.4021685,38.4355319 49.4021685,24.9075 C49.4021685,11.3794681 38.4355319,0.412831492 24.9075,0.412831492 C11.3794681,0.412831492 0.412831492,11.3794681 0.412831492,24.9075 C0.412831492,38.4355319 11.3794681,49.4021685 24.9075,49.4021685 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Opacity",
    opacity: 0.12344215,
    transform: "translate(4.128315, 4.128315)",
    fill: "#F8E71C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7791851,41.4207597 C9.37915823,41.4207597 0.137610497,32.1792119 0.137610497,20.7791851 C0.137610497,9.37915823 9.37915823,0.137610497 20.7791851,0.137610497 C32.1792119,0.137610497 41.4207597,9.37915823 41.4207597,20.7791851 C41.4207597,32.1792119 32.1792119,41.4207597 20.7791851,41.4207597 Z M20.7791851,41.1455387 C32.0272116,41.1455387 41.1455387,32.0272116 41.1455387,20.7791851 C41.1455387,9.53115859 32.0272116,0.412831492 20.7791851,0.412831492 C9.53115859,0.412831492 0.412831492,9.53115859 0.412831492,20.7791851 C0.412831492,32.0272116 9.53115859,41.1455387 20.7791851,41.1455387 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.9075,41.1455387 C15.9394789,41.1455387 8.66946133,33.8755211 8.66946133,24.9075 C8.66946133,15.9394789 15.9394789,8.66946133 24.9075,8.66946133 C33.8755211,8.66946133 41.1455387,15.9394789 41.1455387,24.9075 C41.1455387,33.8755211 33.8755211,41.1455387 24.9075,41.1455387 Z M24.9075,40.8703177 C33.7235208,40.8703177 40.8703177,33.7235208 40.8703177,24.9075 C40.8703177,16.0914792 33.7235208,8.94468232 24.9075,8.94468232 C16.0914792,8.94468232 8.94468232,16.0914792 8.94468232,24.9075 C8.94468232,33.7235208 16.0914792,40.8703177 24.9075,40.8703177 Z",
    id: "Shape",
    fill: "#FFF24A"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFF24A",
    cx: 26.5,
    cy: 26.4144897,
    r: 16.0621948
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#111C31",
    cx: 19.6972275,
    cy: 26.4144897,
    r: 2.19722748
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#111C31",
    cx: 26.6972275,
    cy: 26.4144897,
    r: 2.19722748
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#111C31",
    cx: 33.6972275,
    cy: 26.4144897,
    r: 2.19722748
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.555b7ff901d4173f8ec0e981bbadb344.svg";
export { ForwardRef as ReactComponent };